export default "__VITE_ASSET__CS$8dGrq__"